import React, { Fragment, useState } from 'react';
import ComboBoxAutocomplete from '../../Reusable/ComboBoxAutocomplete';

const ComboBoxDemo = () => {
  const [state, setState] = useState({
    autocomplete: null,
    autocompleteCustom: null,
    autocompleteFiltered: null,
  });

  const onComboBoxChangeHandler = (name, value) => {
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <Fragment>
      <ComboBoxAutocomplete
        id="autocomplete"
        data={['admin', 'direktor', 'autor']}
        textExtractor={(a) => a}
        changeValue={(newValue) =>
          onComboBoxChangeHandler('autocomplete', newValue)
        }
        label={'Autocomplete'}
        updateValue={state.autocomplete}
      />
      <ComboBoxAutocomplete
        id="autocomplete-disclude-selected"
        data={['admin', 'direktor', 'autor']}
        textExtractor={(a) => a}
        changeValue={(newValue) =>
          onComboBoxChangeHandler('autocompleteFiltered', newValue)
        }
        label={'Autocomplete disclude selected'}
        updateValue={state.autocompleteFiltered}
        filterSelectedOptions
      />
      <ComboBoxAutocomplete
        id="autocompleteCustom"
        data={[
          {
            id: 1,
            name: 'admin',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
          },
          {
            id: 2,
            name: 'direktor',
            description: 'Lorem ipsum dolor sit amet.',
          },
          {
            id: 3,
            name: 'autor',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          },
        ]}
        textExtractor={(a) => a.name}
        changeValue={(newValue) =>
          onComboBoxChangeHandler('autocompleteCustom', newValue)
        }
        label={'Autocomplete custom option'}
        updateValue={state.autocompleteCustom}
        renderOption={(option) => (
          <section className="mb-0">
            <b>{option.name}</b>
            <p>{option.description}</p>
          </section>
        )}
      />
    </Fragment>
  );
};

export default ComboBoxDemo;
